import React, { useState, useEffect, lazy,Suspense } from 'react';
import images_WhatsApppng0 from "../../assets/images/images_WhatsApp.png";
import { useLocation, useParams } from 'react-router';
// import ReactHtmlParser from 'react-html-parser';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
// import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Check from '@material-ui/icons/Check';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from "@material-ui/core/styles";

import { devConsolelog, getApi,  postPrivateApi,
  queryStringToObj, isEmptyObject, openWhatsApp ,LoadingComponent} from '../../Utility';
import ImageCarousel from '../Commons/imageCarousel';
import ListingVisualItenery from '../Commons/ampVisualItenery';
import {
  INCLUSIONS, THEME_SECONDARY_COLOR, UNIT_NAMES, B2B2C_API_PUBLIC_VERSION,
   API_DOMAIN_URL_RESELLER, API_SECTION_RESELLER_LISTINGS, API_SECTION_LISTINGS, API_ENDPOINT_RESELLER_LISTING,
    API_SECTION_LMS, API_ENDPOINT_CUSTOMER_QUOTES,
   API_DOMAIN_B2B2C, API_SECTION_NOTIFICATION, API_ENDPOINT_SEND
} from '../../Constants';
import NotFound from '../Commons/404';
import useStyles from './styles';


const ReactHtmlParser = lazy(() =>
  import("../Commons/ReactHtmlParser")
);

export default () => {
  const [listing, setListing] = useState({});
  const [currentInclusions, setCurrentInclusions] = useState([]);
  const [noApiResponse, setNoApiResponse] = useState(false);
  const [showVisualItenery, setShowVisualItenery] = useState(false);
  const [cardIdsQueryString, setCardIdsQueryString] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const classes = useStyles();
  const match = useParams();
  let location = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const searchParam = queryStringToObj(location.search);

  let { member = {}, title } = listing;


  const whatsappMsg = `Hi! I am interested in '${title}' deal. Can you please share more details?
  ${window.location.href}`;

  useEffect(() => {
    const fetchDetails = async () => {
      let searchParamValue = null;
      let url = null;
      let dataKey = null;
      if ('customer_quote' in searchParam || 'customerQuoteId' in match) {
        searchParamValue = searchParam['customer_quote'] || match.customerQuoteId;
        url = `${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_LMS}${API_ENDPOINT_CUSTOMER_QUOTES}${searchParamValue}/`
        dataKey = 'quote'
        setErrorMessage("Quote not found")
      } else if ('package' in searchParam || 'resellerListingId' in match) {
        searchParamValue = searchParam['package'] || match.resellerListingId
        url = `${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_LISTINGS}/${API_ENDPOINT_RESELLER_LISTING}${searchParamValue}/`
        dataKey = 'listing'
        setErrorMessage("Package not found")
      }

    //  const packageValue = searchParam['package'];
      if (searchParamValue) {
        let { data = {}, status, err = null } = await getApi(url);
        if (status >= 200 && status < 300) {
          data[dataKey].price = data.price;
          data[dataKey].currency = data.currency;
          data[dataKey].member = data.member;
          if(dataKey == 'listing') {
            data[dataKey].resellerId = data.id;
            sendNotification(data[dataKey])
          }
          setListing(data[dataKey]);
          let newState = {}, { inclusions = [], cards = [] } = data[dataKey] || {};
          if (inclusions && inclusions.length > 0) {
            inclusions.forEach(item => newState[item.id] = true)
            setCurrentInclusions(newState);
          }
          if(cards && cards.length > 0) {
            let cardIdsQueryString = '';
            cards.forEach((item, index) => {
              if(!item.cms_card_id) return;
              cardIdsQueryString += `${item.cms_card_id}`;
              if(index < cards.length - 1) cardIdsQueryString += `,`;
            })
            setCardIdsQueryString(cardIdsQueryString);
          }
        } else {
          setNoApiResponse(true)
        }
      }
    }
    fetchDetails();
  }, [])

  const sendNotification = async (listing={}) => {
    if(isEmptyObject(listing)) return;
    const {id: lms_listing_id=null, resellerId: lms_reseller_listing_id=null, destination=null} = listing || {}
    const {data={}, err, status=null} = await postPrivateApi(`${API_DOMAIN_B2B2C}${API_SECTION_NOTIFICATION}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_SEND}`,{
      lms_listing_id,
      lms_reseller_listing_id,
      destination
    })
    if(err) {
      return
    }
    if(status>=200 && status<300) devConsolelog('notification send successfully')
  }

  const HeaderJsx = (<Card className={classes.header}>
    {
      !isEmptyObject(listing) && listing.member.name && <Typography variant="h4" style={{padding:10}}>{`${member.company_name || ""} ${member.name && `(${member.name})`}`}</Typography>
    }
  </Card>)

  const DetailImagesJsx = (<Card className={classes.images}>
    {
      listing.images && (<ImageCarousel title={listing.title || ""} images={listing.images} />)
    }
  </Card>)

  const DetailsJsx = (<Card className={classes.details}>
    {
      !isEmptyObject(listing) && (<CardContent className={classes.detailsFlexForChat}>
        <Typography variant="h4">
          {listing.currency ? listing.currency.symbol : ""} {listing.price || ""} <Typography variant="subtitle2" display="inline" color="textSecondary">{UNIT_NAMES[listing.unit_type] || ""}</Typography>
        </Typography>
        <Button className={classes.chatButton} onClick={() => openWhatsApp(member.phone, whatsappMsg)} variant="contained" fullWidth ><img src={images_WhatsApppng0} />Click to chat</Button>
        {cardIdsQueryString && (<Button variant="contained" className={classes.newButton} fullWidth onClick={() => setShowVisualItenery(true)}>Visual Itinerary</Button>)}
        <br />
      </CardContent>)
    }
  </Card>)



  const DescriptionJsx = (<Card className={classes.description}>
    {
      listing.description && (<CardContent>
        <Typography variant="h5">Description</Typography>
        <div className={classes.descriptionText}>
          {/** ReactHtmlParser(listing.description) **/}
          <Suspense fallback={<LoadingComponent />}>
          <ReactHtmlParser data={listing.description} />
          </Suspense>
        </div>
      </CardContent>)
    }
  </Card>)

  const InclusionsJsx = (<Card className={classes.inclusions}>
    {
      listing.inclusions && (<CardContent className={classes.detailsFlex}>
        <Typography variant="h5">Inclusions</Typography>
        <div className={classes.inclusionsFlex}>
          {
            INCLUSIONS.map((item, index) => (
              <Typography key={index} variant="subtitle2" color={currentInclusions[item.id] ? 'secondary' : "textSecondary"}>
                <span>{item.name ? item.name : ""}</span>
                <Check
                  style={
                    currentInclusions[item.id]
                      ? { color: `${THEME_SECONDARY_COLOR}`, verticalAlign: 'middle' }
                      : { color: 'transparent', verticalAlign: 'middle' }
                  }
                />
              </Typography>))
          }
        </div>

        {
          listing.nights_count
            ? (<React.Fragment>
              <Typography variant="h5" style={{ marginTop: 10 }}>Number of Nights</Typography>
              <Typography variant="subtitle2" color="textPrimary">{listing.nights_count}</Typography>
            </React.Fragment>)
            : <div></div>
        }

        {
          listing.hotel_name_room_category_meal_plan ? (<React.Fragment>
            <Typography variant="h5" style={{ marginTop: 10 }}>Hotel Name</Typography>
            <Typography variant="subtitle2" color="textPrimary">{listing.hotel_name_room_category_meal_plan}</Typography>
          </React.Fragment>)
            : <div></div>
        }
      </CardContent>)
    }
  </Card>)

  return (
  <div className={classes.root}>
    { !isEmptyObject(listing) && (<Button className={classes.chatButtonMobile} onClick={() => openWhatsApp(member.phone, whatsappMsg)} variant="contained" size="small" ><img src={images_WhatsApppng0} />Click to chat</Button>) }
    <Container>
      <div className={classes.gridContainer}>
        {
          isSmallScreen
          ? (<>
            {HeaderJsx}
            {DetailImagesJsx}
            {DetailsJsx}
            {InclusionsJsx}
            {/** DocumentsJsx**/}
            {DescriptionJsx}
          </>)
          : (<>
            <div className={classes.box0}>{HeaderJsx}</div>
            <div className={`${classes.desktopFlexWrapper} ${classes.box1}`}>
              {DetailImagesJsx}
              {DescriptionJsx}
            </div>
            <div className={`${classes.desktopFlexWrapper} ${classes.box2}`}>
              {DetailsJsx}
              {InclusionsJsx}
              {/** DocumentsJsx **/}
            </div>
          </>)
        }
      </div>
    </Container>
    {/**
      showVisualItenery && (<MyDailogModal
        // titleText={`Visual Itenery`}
        bodyText={<ListingVisualItenery cardIdsQueryString={cardIdsQueryString} />}
        actions={
          [
            {
              name: "Close",
              onClick: () => setShowVisualItenery(false)
            }
          ]
        }
        openDailog={true}
        fullScreen={false}
        onClose={() => setShowVisualItenery(false)}
      />)
    **/}
    {
      showVisualItenery && (<ListingVisualItenery cardIdsQueryString={cardIdsQueryString} onClose={() => setShowVisualItenery(false)}/>)
    }
    {
      noApiResponse && <NotFound message={errorMessage} />
    }
  </div>
  )
}

// <Modal
//   aria-labelledby="simple-modal-title"
//   aria-describedby="simple-modal-description"
//   open={true}
//   onClose={() => setShowVisualItenery(false)}
// >
//   <div className={classes.modalView}><ListingVisualItenery cardIdsQueryString={cardIdsQueryString} /></div>
// </Modal>
